
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/ueberuns/fachkompetenz/modal-slaudani.kpa`,
      template: `<div class="modal-slaudani">
        <div class="column">
            <a href="https://www.laudani-gmbh.de/" target="_blank"><img src="/images/team/laudani-logo.svg" alt="Laudani GmbH Logo"></a>

            <div class="content">
                <h3>Laudani GmbH</h3>

                <p>
                    Die <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> ist seit über 25 Jahren ein führender Anbieter für Immobiliensanierungen und Instandhaltungsarbeiten in Köln und Umgebung. Mit ihrem umfangreichen Know-how und der langjährigen Expertise im Bereich Gebäudesanierung hat sich die <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> einen exzellenten Ruf aufgebaut. Von der Komplettsanierung über Renovierungen bis hin zur Wartung und Pflege Ihrer Immobilie - bei der <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> erhalten Sie alles aus einer Hand. 
                </p>
            </div>
        </div>
    </div>`,
      style: `modal-slaudani .modal-slaudani {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
modal-slaudani .modal-slaudani .column {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
modal-slaudani .modal-slaudani .column img {
  align-self: center;
  width: 250px;
  height: auto;
}
modal-slaudani .modal-slaudani .column h3 {
  text-align: left;
}
modal-slaudani .modal-slaudani .column p {
  text-align: left;
}
@media (max-width: 800px) {
  modal-slaudani .modal-slaudani .column {
    flex-flow: column nowrap;
  }
  modal-slaudani .modal-slaudani .column img {
    align-self: flex-start;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  